var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGolf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Golf-Hole-Aim--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Golf Hole Aim Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.23 21.06a1.72 1.72 0 1 0 3.44 0 1.72 1.72 0 1 0 -3.44 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.19 3.44A1 1 0 0 0 22 4.1l-4.61 15.69 -1.19 -0.43a2.46 2.46 0 0 0 -3.2 1.4 2.43 2.43 0 0 0 0.05 1.87A2.21 2.21 0 0 0 14.78 24l2 0a2 2 0 0 0 1.84 -1.33l5.26 -18a1 1 0 0 0 -0.69 -1.23Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.84 14.19c0 -1.84 -2.76 -3.3 -6.36 -3.42a0.49 0.49 0 0 0 -0.36 0.13 0.53 0.53 0 0 0 -0.15 0.36v2a0.74 0.74 0 0 1 -1.47 0V6.38l3.68 -1.74A1.49 1.49 0 0 0 10 3.29 1.46 1.46 0 0 0 9.15 2L5 0.09a1 1 0 0 0 -1 0.07 1 1 0 0 0 -0.43 0.84l0 10.22c-2.06 0.59 -3.44 1.69 -3.44 3 0 1.93 3 3.43 6.87 3.43s6.84 -1.53 6.84 -3.46Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGolf);
export default ForwardRef;